'use client';

import { createSlice } from '@reduxjs/toolkit';
import { IProductsState } from '../types';

const initialState : IProductsState = {
  products: [],
  currentPage: 1,
  links: {},
  status: '',
};


export const productsSlice = createSlice({
  name: 'products',
  initialState,
  reducers: {
    changeState: (state, action) => {
      return {
        ...state, ...action.payload
      }
    }
  },
});

export const { changeState } = productsSlice.actions;
export default productsSlice.reducer;
